import styled, { keyframes } from "styled-components"

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const scaleIn = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.92);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
`

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(4, 16, 29, 0.76);
  z-index: 1000;
  animation: ${fadeIn} 0.4s ease-in-out;
  backdrop-filter: blur(9px);
`

export const PopupContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  display: grid;
  grid-template-columns: minmax(0, 1.08fr) minmax(420px, 0.92fr);
  background: #f5f8fb;
  color: #172c42;
  width: min(1040px, 92vw);
  border-radius: 2px;
  border: 1px solid rgba(184, 201, 216, 0.75);
  box-shadow: 0 48px 140px rgba(2, 12, 24, 0.55);
  overflow: hidden;
  z-index: 1100;
  animation: ${scaleIn} 0.45s cubic-bezier(0.21, 1, 0.32, 1) forwards;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
    width: min(560px, 92vw);
    max-height: 92vh;
    overflow-y: auto;
  }
`

export const ImageSection = styled.div<{ $image: string }>`
  position: relative;
  width: 100%;
  min-height: 100%;
  background-image: url(${({ $image }) => JSON.stringify($image)});
  background-size: cover;
  background-position: center;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(145deg, rgba(6, 24, 43, 0.08), rgba(6, 24, 43, 0.58));
  }

  &::after {
    content: "";
    position: absolute;
    inset: 0 0 auto;
    height: 4px;
    background: #4b9bd8;
  }

  @media (max-width: 960px) {
    height: 190px;
  }
`

export const ContentSection = styled.div`
  position: relative;
  padding: clamp(3rem, 6vw, 4.75rem);
  display: grid;
  gap: 1.4rem;
  align-content: center;
  justify-items: start;

  @media (max-width: 960px) {
    padding: clamp(2rem, 6vw, 3rem);
    justify-items: start;
    text-align: left;
  }
`

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 42px;
  height: 42px;
  border-radius: 2px;
  border: 1px solid #b9c9d6;
  background: rgba(245, 248, 251, 0.92);
  color: #173a5d;
  font-size: 1.2rem;
  line-height: 1;
  cursor: pointer;
  display: grid;
  place-items: center;
  z-index: 1;
  transition:
    transform 0.2s ease,
    background 0.2s ease,
    border-color 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    background: #173a5d;
    border-color: #173a5d;
    color: #ffffff;
  }
`

export const PopupEyebrow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.7rem;
  padding: 0;
  color: #337abd;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;

  &::before {
    content: "";
    width: 2.5rem;
    height: 1px;
    background: currentColor;
  }
`

export const PopupTitle = styled.h2`
  margin: 0;
  font-size: clamp(2.5rem, 4.8vw, 4.2rem);
  line-height: 0.98;
  letter-spacing: -0.055em;
  font-weight: 700;
  color: #102f4f;
`

export const PopupText = styled.p`
  margin: 0;
  color: #52687c;
  font-size: 1rem;
  line-height: 1.7;
  max-width: 420px;

  @media (max-width: 960px) {
    max-width: 520px;
  }
`

export const PopupButton = styled.button`
  min-height: 54px;
  padding: 0 clamp(1.5rem, 4vw, 2.2rem);
  border-radius: 3px;
  border: 1px solid #175f98;
  font-size: 1rem;
  font-weight: 600;
  color: #ffffff;
  background: #175f98;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  transition:
    transform 0.25s ease,
    box-shadow 0.25s ease;
  box-shadow: 0 14px 30px rgba(23, 95, 152, 0.2);

  &::after {
    content: "→";
    font-size: 1.15rem;
  }

  &:hover {
    transform: translate3d(0, -1px, 0);
    background: #0d4172;
    border-color: #0d4172;
    box-shadow: 0 18px 38px rgba(23, 95, 152, 0.28);
  }
`

export const PopupHelper = styled.span`
  font-size: 0.85rem;
  color: #718395;
  text-align: left;

  @media (max-width: 960px) {
    text-align: left;
  }
`
